<script setup>
import { computed } from "vue";
import MarsIcon from "@/components/icon/MarsIcon.vue";
import VenusIcon from "@/components/icon/VenusIcon.vue";

const props = defineProps({
  gender: {
    type: Number,
    default: 0,
    validate(value) {
      return [0, 1, 2, 3].includes(value);
    },
  },
  padding: {
    type: Boolean,
    default: false,
  },
});

const shouldDisplay = computed(() => {
  return props.gender === 1 || props.gender === 2;
});
</script>
<template>
  <div
    v-if="shouldDisplay"
    class="h-full aspect-[1/1] rounded flex justify-center items-center p-0.5"
    :class="{
      male: props.gender === 1,
      female: props.gender === 2,
    }"
  >
    <MarsIcon class="h-full w-full" v-if="gender === 1" />
    <VenusIcon class="h-full w-full" v-else-if="gender === 2" />
  </div>
  <div v-else-if="padding" class="-ml-3"></div>
</template>
<style scoped>
.male {
  @apply text-indigo-500;
}
.female {
  @apply text-pink-500;
}
</style>
